/**
 * 医生停诊模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';


// 新增医生停诊
export const stopAdd = (params) => {
  return req.post('/scheduling/medical', params);
}

// 获取医生停诊列表
export const stopList = (params) => {
  return req.get('/scheduling/medical/list', params);
}

// 取消停诊
export const stopCancel = (stopIds) => {
  return req.post(`/scheduling/medical/cancel/${stopIds}`);
}